import { StepDefinition } from "../../../../core/flows/StepDefinition";
import { StepFlow } from "../../../../core/flows/StepFlow";
import { SelectOfferContext } from "../Context/SelectOfferContext";

class SelectOfferInitStep extends StepFlow {
    get stepName() { return "SelectOfferInit_Step"; }

    async onExecute(): Promise<void> {
        console.log("SelectOffer_Init step call.................................")        
        const context = this.getCtx<SelectOfferContext>("SelectOfferContext")!
        context.routeTo = ["SelectOffer_Step"]
        this.next()
    }

}
export const selectOfferInitStepDefinition = new StepDefinition({
    stepName: "SelectOfferInit_Step",
    stepClass: SelectOfferInitStep
});